export enum PmStatus {
  occurred = 'Occurred',
  cancelled = 'Cancelled',
  lateCancelled = 'Late Cancellation',
  noShow = 'No-Show',
  rescheduled = 'Re-Scheduled',
}

export type MeetingFilter =
  | 'all'
  | 'future'
  | 'upcoming'
  | 'past'
  | 'ended'
  | 'didnt-occur';

enum ProviderType {
  Coach = 'Coach',
  Pharmacist = 'Pharmacist',
  Provider = 'Provider',
  Dietitian = 'Dietitian',
}

enum SupervisorStatus {
  supervised = 'supervised',
  supervising = 'supervising',
}

export type Provider = {
  id: number;
  display_name: string;
  full_name: string;
  healthie_id: number;
  image_url: string;
  supervisor_status: SupervisorStatus | null;
  type: ProviderType;
};

export type Meeting = {
  client_confirmed: boolean;
  healthie_appointment_id: number;
  meeting_date: string;
  meeting_type: string;
  metadata: any;
  pm_status: PmStatus;
  provider?: Provider;
};
